<template>
    <div class="stamp-base">
        <div class="circular-stamp" :style="stampStyle">
            <span class="stamp-text" :style="textStyle">{{ text }}</span>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        text: {
            type: String,
            default: "已发送",
        },
        size: {
            type: Number,
            default: 1.1,
        },
        stampColor: {
            type: String,
            default: "#FF4500",
        },
        textColor: {
            type: String,
            default: "#CD5632",
        },
        backgroundColor: {
            type: String,
            default: "transparent",
        },
        fontSize: {
            type: String,
            default: "0.3rem",
        },
    },
    computed: {
        stampStyle() {
            return {
                width: `${this.size}rem`,
                height: `${this.size}rem`,
                borderRadius: "50%",
                background: this.stampColor,
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: this.textColor,
                fontWeight: "bold",
                fontFamily: "Arial, sans-serif",
                fontSize: this.fontSize,
                cursor: "pointer",
                position: "absolute",
                top: "50%",
                transform: "translateX( -50%)",
                right:"-0.3rem",
                backgroundColor: this.backgroundColor,
            };
        },
        textStyle() {
            return {
                fontSize: this.fontSize,
                transform: "rotate(-25deg)",
            };
        },
    },
};
</script>
  
<style scoped>
.stamp-base {
    position: relative;
}
</style>
  